// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"84d4fec5","57":"b02851de","85":"ace2174b","124":"c8188b23","353":"c4b88628","453":"038c151b","660":"dff304d2","697":"871fc4a5","712":"3bfa9f9c","819":"b41b6b63","986":"3bd9aff0"}[chunkId] + ".chunk.js";
};